import { ActionTypes } from "../type";

const initialState = {
  isAuthenticated: false,
  isInitializes: false,
  user: null,
  token_values: null,
  loading: true,
  franchise_id: 0,
  sub_franchise: 0,
  is_super_franchise: 0,
  is_franchise_employee: 0,
};


export const jwtAuthreducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.INITIALIZE:
      return {
        ...state,
        isInitializes: true,
        isAuthenticated: action.payload.isAuthenticated,
        user: action.payload.user,
        token_values: action.payload.token_values,
        sub_franchise: action?.payload?.subObject?.sub_franchise,
        franchise_id: action?.payload?.subObject?.franchise_id,
        is_super_franchise: action?.payload?.subObject?.is_super_franchise,
        is_franchise_employee: action?.payload?.subObject?.is_franchise_employee,
      };
    case ActionTypes.LOGIN: {
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        token_values: action.payload.token_values,
        sub_franchise: action?.payload?.subObject?.sub_franchise,
        franchise_id: action?.payload?.subObject?.franchise_id,
        is_super_franchise: action?.payload?.subObject?.is_super_franchise,
        is_franchise_employee: action?.payload?.subObject?.is_franchise_employee,
      };
    }
    case ActionTypes.LOADING:
      return {
        ...state,
        loading: action.payload.loading,
      };
    case ActionTypes.LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        token_values: null,
        sub_franchise: null,
        is_super_franchise: null,
        is_franchise_employee: null,
        franchise_id: null,
      };
    default:
      return state;
  }
};
